import { jsx } from "react/jsx-runtime";
import { styled } from "@mui/material";
import { validateTidalLicense } from "@workwave-tidal/core/base";
const Container = styled("div", { name: "Container" })((_theme) => ({
  // Spacer that allow the label to not be cut (outlined label will overflow the container)
  paddingTop: "5px"
}));
function FieldsContainer(props) {
  const { children, testId = "fields-container-root" } = props;
  return /* @__PURE__ */ jsx(Container, { "data-testid": testId, children });
}
validateTidalLicense();
export {
  FieldsContainer
};
//# sourceMappingURL=FieldsContainer.js.map
